/* ============================================
   WITH—BY— Theme v2 — Global JavaScript
   ============================================ */
(function () {
  'use strict';

  /* ── SCROLL ANIMATIONS (FadeIn on scroll) ── */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-in').forEach(function(el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in').forEach(function(el) { obs.observe(el); });
  }

/* ── HEADER HIDE/SHOW ON SCROLL ── */
  function initHeaderScroll() {
    var wrap = document.getElementById('site-header-wrap');
    var header = document.querySelector('.site-header');
    if (!wrap || !header) return;
    // Sur le configurateur, pas de hide/show
    if (header.classList.contains('on-configurator')) return;
    // Sur la page À propos, le header est en position:fixed, pas de hide/show
    if (document.body.classList.contains('template-page-a-propos')) return;

    var lastY = window.scrollY;
    var ticking = false;
    var threshold = 80; // doit être > hauteur announcement (35px) pour éviter le flicker au tout début

    function update() {
      var y = window.scrollY;
      var goingDown = y > lastY;
      if (goingDown && y > threshold) {
        wrap.classList.add('is-hidden');
      } else if (!goingDown) {
        wrap.classList.remove('is-hidden');
      }
      // Clamp pour éviter les valeurs négatives (overscroll mobile)
      lastY = y <= 0 ? 0 : y;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── SCROLL TO TOP ── */
  function initScrollTop() {
    var btn = document.getElementById('scroll-top');
    if (!btn) return;
    window.addEventListener('scroll', function() {
      btn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ── CART NOTIFICATION ── */
  window.WBShowCartNotification = function(msg) {
    var n = document.getElementById('cart-notification');
    var t = document.getElementById('cart-notification-text');
    if (!n || !t) return;
    t.textContent = msg || 'Produit ajouté au panier';
    n.classList.add('visible');
    setTimeout(function() { n.classList.remove('visible'); }, 3000);
  };

  window.WBUpdateCartCount = function(count) {
    var badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  };

  window.WBFetchCartCount = function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      window.WBUpdateCartCount(c.item_count);
    }).catch(function(){});
  };

/* ── NAV DRAWER v3 ── */
  function initNavDrawer() {
    var toggle = document.getElementById('menu-toggle');
    var drawer = document.getElementById('nav-drawer');
    var overlay = document.getElementById('nav-overlay');
    var closeBtn = document.getElementById('nav-close');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('nav-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      /* Referme aussi les sous-menus pour repartir propre */
      drawer.querySelectorAll('.nd-item--expandable.is-open').forEach(function(it) {
        it.classList.remove('is-open');
        var btn = it.querySelector('[aria-expanded]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Ferme le drawer au clic sur un lien simple (pas un bouton expandable) */
    drawer.querySelectorAll('a.nd-link, a.nd-sub-link').forEach(function(link) {
      link.addEventListener('click', close);
    });

    /* Bouton LFC Tube : toggle du sous-menu */
    drawer.querySelectorAll('.nd-link--expandable').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var item = btn.closest('.nd-item--expandable');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }
  
  /* ── FOOTER LANGUAGE DROPDOWN ── */
  function initFooterLang() {
    var btn = document.getElementById('footer-lang-btn');
    var dropdown = document.getElementById('footer-lang-dropdown');
    if (!btn || !dropdown) return;

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = dropdown.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function() {
      dropdown.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── GENERIC SLIDESHOW ── */
  window.WBInitSlideshow = function(container) {
    if (!container) return;
    var slides = container.querySelectorAll('.wb-slide');
    var dots = container.querySelectorAll('.wb-dot');
    var prevBtns = container.querySelectorAll('.wb-prev');
    var nextBtns = container.querySelectorAll('.wb-next');
    var current = 0;
    if (!slides.length) return;

    function goTo(idx) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    prevBtns.forEach(function(b) { b.addEventListener('click', function() { goTo(current - 1); }); });
    nextBtns.forEach(function(b) { b.addEventListener('click', function() { goTo(current + 1); }); });
    dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); }); });

    // Touch swipe
    var startX = 0;
    container.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    container.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    goTo(0);
  };

  document.querySelectorAll('.wb-slideshow').forEach(function(s) { window.WBInitSlideshow(s); });

  /* ── PARALLAX ── */
  function initParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;

    function update() {
      els.forEach(function(el) {
        var speed = parseFloat(el.dataset.parallax) || 0.1;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var vCenter = window.innerHeight / 2;
        var offset = (vCenter - center) * speed;
        var img = el.querySelector('.parallax-img');
        if (img) img.style.transform = 'translateY(' + offset + 'px) scale(1.15)';
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollAnimations();
    initHeaderScroll();
    initScrollTop();
    initNavDrawer();
    initFooterLang();
    initParallax();
    window.WBFetchCartCount();
  });
/* ── Réorganisation contrôles slideshow en mobile ── */
  function reorgSlideshowControls() {
    if (window.innerWidth >= 768) return;
    document.querySelectorAll('.wb-slideshow .wb-slide').forEach(function(slide) {
      if (slide.dataset.ctrlReorg) return;
      /* Skip les slides "Cercle" : ils gardent leur structure native (flèches sous l'image+texte) */
      if (slide.querySelector('.wbcircle-card')) return;
      /* Tous les boutons du slide : les 2 premiers sont les flèches nav, les autres sont les dots */
      var allButtons = slide.querySelectorAll('button');
      var arrows = [];
      var dots = [];
      allButtons.forEach(function(b) {
        if (b.classList.contains('slide-dot')) dots.push(b);
        else arrows.push(b);
      });
      if (arrows.length < 2 || dots.length < 1) return;

      /* Construit la barre de contrôle unifiée */
      var controls = document.createElement('div');
      controls.className = 'wb-ss-controls';

      arrows[0].classList.add('wb-ss-arrow');
      arrows[1].classList.add('wb-ss-arrow');

      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'wb-ss-dots-inner';
      dots.forEach(function(d) { dotsWrap.appendChild(d); });

      controls.appendChild(arrows[0]);
      controls.appendChild(dotsWrap);
      controls.appendChild(arrows[1]);

      /* Insère la barre à la fin du container interne du slide */
      var target = slide.firstElementChild || slide;
      target.appendChild(controls);

      slide.dataset.ctrlReorg = '1';
    });
  }
  document.addEventListener('DOMContentLoaded', reorgSlideshowControls);
  window.addEventListener('load', reorgSlideshowControls);
})();
// ────────────────────────────────────────────
// ABOUT OVERLAY : ouvrir/fermer au clic sur les liens "À propos"
// ────────────────────────────────────────────
(function() {
  var overlay = document.getElementById('about-overlay');
  if (!overlay) return;
  
  var closeBtn = document.getElementById('about-overlay-close');
  var scrollArea = overlay.querySelector('.about-overlay-scroll');
  
  function openOverlay(e) {
    if (e) e.preventDefault();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('about-overlay-open');
    // Fermer le drawer si ouvert
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-overlay');
    if (navDrawer) navDrawer.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
    // Remet le scroll interne en haut
    if (scrollArea) scrollArea.scrollTop = 0;
  }
  
  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('about-overlay-open');
  }
  
  // Cibler tous les liens qui pointent vers /pages/a-propos
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/pages/a-propos"]');
    if (link) {
      openOverlay(e);
    }
  });
  
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  
  // Fermer avec Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });
})();
// ────────────────────────────────────────────
// CONTACT OVERLAY : ouvrir/fermer au clic sur les liens "Contact"
// ────────────────────────────────────────────
(function() {
  var overlay = document.getElementById('contact-overlay');
  if (!overlay) return;
  
  var closeBtn = document.getElementById('contact-overlay-close');
  var scrollArea = overlay.querySelector('.contact-overlay-scroll');
  
  function openOverlay(e) {
    if (e) e.preventDefault();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('contact-overlay-open');
    // Fermer le drawer si ouvert
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-overlay');
    if (navDrawer) navDrawer.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
    // Remet le scroll interne en haut
    if (scrollArea) scrollArea.scrollTop = 0;
  }
  
  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('contact-overlay-open');
  }
  
  // Cibler tous les liens qui pointent vers /pages/contact (et contact-1)
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/pages/contact"]');
    if (link) {
      openOverlay(e);
    }
  });
  
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  
  // Fermer avec Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });
  
  // Auto-ouvrir si le formulaire vient d'être soumis (après reload)
  if (window.location.hash === '#contact-success' || 
      (document.querySelector('.contact-overlay-success'))) {
    openOverlay();
  }
  // Textarea Message : auto-grandit avec le contenu
  var textarea = overlay.querySelector('.contact-overlay-textarea');
  if (textarea) {
    function autoGrow() {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
    textarea.addEventListener('input', autoGrow);
    // Au premier affichage
    setTimeout(autoGrow, 100);
  }
})();
// ────────────────────────────────────────────
// LEGAL OVERLAY : ouvrir/fermer + navigation
// ────────────────────────────────────────────
(function() {
  var overlay = document.getElementById('legal-overlay');
  if (!overlay) return;
  
  var closeBtn = document.getElementById('legal-overlay-close');
  var scrollArea = overlay.querySelector('.legal-overlay-scroll');
  var navLinks = overlay.querySelectorAll('.legal-overlay-menu-link');
  
  function openOverlay(e, targetBlockId) {
    if (e) e.preventDefault();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('legal-overlay-open');
    var navDrawer = document.getElementById('nav-drawer');
    var navOverlay = document.getElementById('nav-overlay');
    if (navDrawer) navDrawer.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
    // Si une section cible est demandée, on scrolle dessus ; sinon, retour en haut
    if (targetBlockId && scrollArea) {
      var target = document.getElementById(targetBlockId);
      if (target) {
        // petit délai pour laisser l'overlay s'ouvrir avant le scroll
        setTimeout(function() {
          scrollArea.scrollTo({ top: target.offsetTop - 40, behavior: 'auto' });
        }, 50);
        return;
      }
    }
    if (scrollArea) scrollArea.scrollTop = 0;
  }
  
  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('legal-overlay-open');
  }
  
  // Trouve le bloc "Politique de confidentialité" / "Privacy policy" dans l'overlay
  // (les liens internes utilisent l'attribut data-target qui pointe sur l'id du bloc)
  function findPrivacyBlockId() {
    var keywords = ['confidentialité', 'confidentialite', 'privacy'];
    var menuLinks = overlay.querySelectorAll('.legal-overlay-menu-link');
    for (var i = 0; i < menuLinks.length; i++) {
      var label = (menuLinks[i].textContent || '').toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (label.indexOf(keywords[k]) !== -1) {
          return menuLinks[i].getAttribute('data-target');
        }
      }
    }
    return null;
  }
  
  // Cibler tous les liens "Mentions légales" (FR + EN) + lien Shopify privacy policy
  document.addEventListener('click', function(e) {
    // Lien Shopify natif vers la politique de confidentialité (bannière cookies, footer, etc.)
    // → on ouvre l'overlay directement sur la section "Politique de confidentialité"
    var privacyLink = e.target.closest('a[href*="/policies/privacy-policy"], a[href$="/policies/privacy"]');
    if (privacyLink && !privacyLink.closest('#legal-overlay')) {
      var blockId = findPrivacyBlockId();
      openOverlay(e, blockId);
      return;
    }
    // Liens vers la page mentions légales du thème → ouverture en haut de l'overlay
    var link = e.target.closest('a[href*="/pages/mentions-legales"], a[href*="/pages/legal-notice"], a[href*="/pages/legal"]');
    if (link && !link.closest('#legal-overlay')) {
      openOverlay(e);
    }
  });
  
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  
  // Escape ferme
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeOverlay();
    }
  });
  
  // Navigation interne : scroll smooth au clic sur un lien de la nav
  navLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var targetId = this.getAttribute('data-target');
      var target = document.getElementById(targetId);
      if (target && scrollArea) {
        var top = target.offsetTop - 40;
        scrollArea.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });
  
  // Highlight de la section active pendant le scroll
  if (scrollArea && navLinks.length > 0) {
    var sections = overlay.querySelectorAll('.legal-overlay-section');
    function updateActiveLink() {
      var scrollTop = scrollArea.scrollTop + 100;
      var activeId = null;
      sections.forEach(function(section) {
        if (section.offsetTop <= scrollTop) {
          activeId = section.id;
        }
      });
      navLinks.forEach(function(link) {
        if (link.getAttribute('data-target') === activeId) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }
    scrollArea.addEventListener('scroll', updateActiveLink, { passive: true });
    setTimeout(updateActiveLink, 100);
  }
})();